export const SET_CONFIRMATION_CALL_STATISTICS = 'SET_CONFIRMATION_CALL_STATISTICS';
export const SET_CONFIRMATION_CALL_LIST = 'SET_CONFIRMATION_CALL_LIST';
export const SET_CONFIRMATION_CALL_LIST_META = 'SET_CONFIRMATION_CALL_LIST_META';
export const SET_ACCOUNT_MANAGERS = 'SET_ACCOUNT_MANAGERS';
export const SET_BRANCHES = 'SET_BRANCHES';
export const SET_NOT_COMPLETED_CONFIRMATION_CALLS = 'SET_NOT_COMPLETED_CONFIRMATION_CALLS';

export const CALL_INIT_STATE = {
    confirmationCallList: [],
    confirmationCallListMeta: {},
    accountManagers: [],
    branches: [],
    confirmationCallStatistics: {
        completed: 0,
        notCompleted: 0,
        total: 0
    },
    notCompletedConfirmationCalls: []
};
